import { SavedOutput } from '@/api/types';

export const handleDownload = (e: React.MouseEvent, out: SavedOutput) => {
  e.stopPropagation();
  if (!out.data?.markdown) return;
  
  try {
    const blob = new Blob([out.data.markdown], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const sanitizedTitle = out.title.replace(/[^a-z0-9]/gi, '_').toLowerCase();
    a.download = `${out.type}_${sanitizedTitle}.md`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (e) {}
};

export const getCardBorderColor = (status?: string) => {
  switch(status) {
    case 'Applied': return 'border-blue-300 dark:border-blue-800/80 hover:border-blue-500 dark:hover:border-blue-500/80 dark:hover:shadow-blue-500/10';
    case 'Interviewing': return 'border-purple-300 dark:border-purple-800/80 hover:border-purple-500 dark:hover:border-purple-500/80 dark:hover:shadow-purple-500/10';
    case 'Offer': return 'border-emerald-300 dark:border-emerald-800/80 hover:border-emerald-500 dark:hover:border-emerald-500/80 dark:hover:shadow-emerald-500/10';
    case 'Rejected': return 'border-rose-300 dark:border-rose-800/80 hover:border-rose-500 dark:hover:border-rose-500/80 dark:hover:shadow-rose-500/10';
    default: return 'border-slate-200 dark:border-slate-800 hover:border-emerald-500/50 dark:hover:border-emerald-500/50'; // To Apply
  }
};

export const getStatusColor = (status?: string) => {
  switch(status) {
    case 'Applied': return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 border-blue-200 dark:border-blue-800/50';
    case 'Interviewing': return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300 border-purple-200 dark:border-purple-800/50';
    case 'Offer': return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800/50';
    case 'Rejected': return 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300 border-rose-200 dark:border-rose-800/50';
    default: return 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-slate-200 dark:border-slate-700'; // To Apply
  }
};

export const isNeedsFollowup = (out: SavedOutput) => {
  if (out.status !== 'Applied') return false;
  const refDate = out.meta?.appliedDate || out.created;
  if (!refDate) return false;
  const daysSince = (new Date().getTime() - new Date(refDate).getTime()) / (1000 * 3600 * 24);
  return daysSince >= 7;
};

export const columns = ['To Apply', 'Applied', 'Interviewing', 'Offer', 'Rejected'] as const;
